/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from "react";

export const Welcome: React.FC = (): JSX.Element => {
    return (
        <div className="card card-welcome jc-border-12 auto-height">
            <div className="card-header card-header-bg">
                <p className="jc-txt-heading fs-5">Welcome</p>
            </div>

            <div className="card-body d-flex flex-column justify-content-between">

                <div className="jc-txt-body" style={{fontSize: "1.3rem"}}>
                    <img src="/images/jc-gates-image.png" className="float-left w-50 me-3" />
                    
                    <p className="mb-2 mb-md-3">This website was designed by the Jewish Cemeteries Maintenance Board to pay tribute to loved ones that are no longer with us.</p>
                </div>

                <div className="jc-txt-body mt-3" style={{fontSize: "1.3rem"}}>
                    <p className="mb-2 mb-md-3">Search for a deceased and interact by:</p>
                    
                    <ul className="fw-bold m-0">
                        <li className="mb-2 mb-md-3">Placing a stone on the deceased’s tombstone.</li>
                        <li className="mb-2 mb-md-3">Buying a leaf on the deceased’s tree of life.</li>
                        <li className="mb-2 mb-md-3">Writing on the deceased’s memorial wall.</li>
                    </ul>
                     
                    <p className="mb-2 mb-md-3">The Jewish Cemeteries Maintenance Board (CMB) is responsible for maintenance of all five Jewish cemeteries in the Cape Peninsula.</p>
                    <p className="mb-2 mb-md-3"><b> The average monthly running costs of maintaining our five Jewish Cemeteries in Cape Town is R175 000. We rely solely on donations to cover these costs.</b></p>
                    <p className="mb-2 mb-md-3">We need your support.</p>
                    
                    <img src="/images/galansky_signature.jpg" style={{width: "40%"}} />
                    <p><b>Sam Galansky</b></p>
                </div>

            </div>

            <div className="card-footer">
                
            </div>
        </div>
    );
}